import { Component, inject, input, output, ViewEncapsulation } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { NotesCommand } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandFieldsLabelKeys, ProductionFieldName } from '@src/suite/common/utils/ml-2-html-utils';

import { TextFieldComponent } from '../../../controls/text-field/text-field';

@Component({
    selector: 'st-notes-command-dialog',
    imports: [LetDirective, TextFieldComponent],
    templateUrl: './notes-command-dialog.html',
    styleUrl: './notes-command-dialog.scss',
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-notes-command-dialog' },
})
export class NotesCommandDialogComponent {
    // injectables
    store = inject(Store);

    // store signals
    languageSettings = this.store.selectSignal(selectI18N);

    // inputs
    public readonly command = input<NotesCommand>();

    // outputs
    readonly commandChange = output<NotesCommand>();
    readonly enterEmitter = output<NotesCommand>();

    // constants
    ProductionFieldName = ProductionFieldName;
    ProductionCommandFieldsLabelKeys = ProductionCommandFieldsLabelKeys;

    // methods
    public onCommandsObjectChange(event: any, fieldName: ProductionFieldName) {
        if (this.command()) {
            this.command()[fieldName] = event;
            this.commandChange.emit(this.command());
        }
    }

    public onEnterSaveCommand(event: any) {
        this.onCommandsObjectChange(event, ProductionFieldName.NOTES);
        this.enterEmitter.emit(this.command());
    }
}
